<template>
  <div class="funcionalidades-panel">
    <div
      v-for="panel in paneles"
      :key="panel.key"
      class="acord-item"
      :class="{ 'is-open': abierto === panel.key }"
    >
      <button
        type="button"
        class="acord-header"
        :class="{ 'is-open': abierto === panel.key }"
        @click="toggle(panel.key)"
      >
        <div class="acord-left">
          <span class="acord-icon material-symbols-outlined">{{ panel.icon }}</span>
          <div>
            <span class="acord-title">{{ panel.label }}</span>
            <span class="acord-sub">{{ panel.desc }}</span>
          </div>
        </div>
        <span class="material-symbols-outlined chevron">
          {{ abierto === panel.key ? 'expand_less' : 'expand_more' }}
        </span>
      </button>
      <div v-show="abierto === panel.key" class="acord-body">
        <component
          :is="panel.component"
          v-if="condicion && abierto === panel.key"
          :idTramite="idTramite"
          :idPrestador="idPrestador"
          :idUsuario="idUsuario"
          @ejecutado="$emit('cargado')"
        />
        <div v-else-if="!condicion" class="panel-bloqueado">
          <span class="material-symbols-outlined" style="font-size:22px">lock</span>
          No disponible en el estado actual del trámite
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CorregirDiagCantidad       from "@/components/CorregirDiagCantidad.vue";
import InactivarCodigosTramite    from "@/components/InactivarCodigosTramite.vue";
import InsertarObservacionTramite from "@/components/InsertarObservacionTramite.vue";
import InactivarLabImgCSV         from "@/components/InactivarLabImgCSV.vue";
import InactivarCodigosCSV        from "@/components/InactivarCodigosCSV.vue";
import CambiarCodigoCarga         from "@/components/CambiarCodigoCarga.vue";
import CargarArchivosPlaCSV          from "@/components/CargarArchivosPlaCSV.vue";

export default {
  name: "FuncionalidadesTramite",
  components: { CorregirDiagCantidad, InactivarCodigosTramite, InsertarObservacionTramite,
                CambiarCodigoCarga,   InactivarLabImgCSV,      InactivarCodigosCSV,
                CargarArchivosPlaCSV},
  props: {
    idTramite:   { type: [Number, String], required: true },
    idPrestador: { type: [Number, String], required: true },
    idPlanilla:  { type: [Number, String], required: true },
    idUsuario: {
      type:     [Number, String],
      default:  null,
      required: false,
      validator: v => v === null || !isNaN(Number(v))
    },
  },
  emits: ["cargado", "anulado"],
  data() {
    return {
      abierto:   null,
      condicion: true,
      paneles: [
        {
          key:       "corregir-diag",
          label:     "Corregir diagnóstico / cantidad",
          desc:      "Normaliza diagnósticos y cantidad en detalle de atenciones",
          icon:      "build",
          component: "CorregirDiagCantidad",
        },
        {
          key:       "inactivar-elemento",
          label:     "Inactivar elemento por trámite",
          desc:      "Inactiva elementos en todas las planillas del trámite",
          icon:      "block",
          component: "InactivarCodigosTramite",
        },		
        {
          key:       "inactivar-img-lab",
          label:     "Inactivar imagen y laboratorio de CSV",
          desc:      "Inactiva códigos de imagen y laboratorio en las planillas del archivo",
          icon:      "block",
          component: "InactivarLabImgCSV",
        },
        {
          key:       "inactivar-codigo",
          label:     "Inactivar códigos de CSV",
          desc:      "Inactiva códigos especificados en las planillas del archivo",
          icon:      "block",
          component: "InactivarCodigosCSV",
        },		
        {
          key:       "insertar-obs-tramite",
          label:     "Insertar observación por trámite",
          desc:      "Inserta observación en todas las planillas del trámite",
          icon:      "clinical_notes",
          component: InsertarObservacionTramite,
        },
        {
          key:       "cambiar-codigo-carga",
          label:     "Cambiar código en trámite - carga",
          desc:      "Reemplaza un código en la carga seleccionada del trámite",
          icon:      "find_replace",
          component: CambiarCodigoCarga,
        },
        {
          key:       "cargar-archivos-csv",
          label:     "Cargar archivos PDF por CSV",
          desc:      "Sube uno o varios PDF a un lote de planillas listadas en un CSV",
          icon:      "upload_file",
          component: CargarArchivosPlaCSV,
        },
      ],
    };
  },
  methods: {
    toggle(key) {
      this.abierto = this.abierto === key ? null : key;
    },
  },
};
</script>
<style scoped>
.funcionalidades-panel {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 4px 0;
}

/* ── Ítem ────────────────────────────────────────────────────── */
.acord-item {
  border: 1px solid #dee2e6;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0,0,0,.05);
  transition: box-shadow .2s;
}
.acord-item.is-open {
  box-shadow: 0 4px 14px rgba(13,110,253,.1);
  border-color: #b6d0fe;
}

/* ── Header ──────────────────────────────────────────────────── */
.acord-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 14px;
  border: none;
  background: #f8f9fa;
  cursor: pointer;
  text-align: left;
  transition: background .15s;
  gap: 10px;
}
.acord-header:hover   { background: #eef2ff; }
.acord-header.is-open { background: #e8f0fe; border-bottom: 1px solid #b6d0fe; }

.acord-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.acord-icon {
  font-size: 22px;
  color: #2563eb;
  flex-shrink: 0;
}
.acord-header.is-open .acord-icon { color: #1d4ed8; }

.acord-title {
  display: block;
  font-weight: 700;
  font-size: .88rem;
  color: #1a1d23;
  line-height: 1.2;
}
.acord-sub {
  display: block;
  font-size: .72rem;
  color: #6c757d;
  margin-top: 1px;
}

.chevron {
  font-size: 20px;
  color: #6c757d;
  flex-shrink: 0;
  transition: transform .2s;
}
.acord-header.is-open .chevron { color: #2563eb; }

/* ── Body ────────────────────────────────────────────────────── */
.acord-body {
  padding: 12px 14px;
  background: #fff;
}

/* Bloqueado */
.panel-bloqueado {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  color: #6c757d;
  font-size: .82rem;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px dashed #dee2e6;
}
</style>